<template>
  <div class="MapShareDialog">
    <el-dialog
      class="customDialog"
      :title="dialogType === 0?'创建分享':(dialogType === 3?'创建分享成功':'地图分享')"
      :visible.sync="isShow"
      @close="onCancel"
      top="15vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="formTitle" v-if="dialogType !== 3">
        <div>
          <img src="../images/share-image.png" alt="img" />
        </div>
        <div class="text">
          <span>{{ dialogType === 0?'创建分享':'地图分享' }}</span>
          <span>分享地图不得发布涉及国家秘密信息和一切违法内容。</span>
        </div>
        <div class="switch" v-if="dialogType !== 0">
          <span class="open" v-if="general.switchs">开</span>
          <span class="close" v-if="!general.switchs">关</span>
          <el-switch
            v-model="general.switchs"
            active-color="#00A4F0"
            inactive-color="rgba(255, 255, 255, 0.2)"
            :disabled="dialogType===1 || dialogType===3"
          >
          </el-switch>
        </div>
      </div>
      <!-- <el-form label-position="left" label-width="100px" label-suffix="：">
        <el-form-item label="分享名称">
          <el-input v-model="shareName" placeholder="请输入20字以内"></el-input>
        </el-form-item>
      </el-form> -->
      <div v-if="dialogType === 0">
        <span class="line3"></span>
        <div class="formContainer">
          <div class="tabs">
            <span
              :class="tabsActive === 0 ? 'active' : ''"
              @click="tabsActive = 0"
              >通用设置</span
            >
            <span
              :class="tabsActive === 1 ? 'active' : ''"
              @click="tabsActive = 1"
              >模块数据权限</span
            >
          </div>
        </div>
        <!--通用设置-->
        <div
          class="formContainer2"
          v-show="tabsActive === 0"
        >
          <div class="title">
            <span class="line"></span>
            <span>分享名称</span>
          </div>
          <el-form :model="general" :rules="rules" ref="nameForm" label-position="left" label-width="10px">
            <el-form-item label="" prop="name">
              <el-input v-model="general.name" :maxlength="20" placeholder="请输入20字以内" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <div class="line2"></div>
          <div class="title">
            <span class="line"></span>
            <span>开启分享地图密码访问</span>
          </div>
          <div class="checkbox">
            <el-checkbox
              v-model="general.accessPasswordEnable"
              @change="changePsdCheck"
              >开启密码设置</el-checkbox
            >
            <span>注：密码设置后他人访问此分享地图时须输入密码</span>
          </div>
          <div class="input">
            <el-form
              :model="general"
              :rules="rules"
              ref="ruleForm"
              v-if="general.accessPasswordEnable"
            >
              <el-form-item label="" prop="accessPassword">
                <el-input
                  :type="isShowPassword ? 'text' : 'password'"
                  @change="isChanged = true"
                  v-model.trim="general.accessPassword"
                  :minlength="4"
                  :maxlength="12"
                  show-word-limit
                  placeholder="请输入4-12位密码（除空格外，区分字母大小写）"
                >
                  <svg
                    class="show-password"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                    slot="suffix"
                    @click="isShowPassword = !isShowPassword"
                  >
                    <use
                      :xlink:href="
                        isShowPassword ? '#icon-browse' : '#icon-eye-close'
                      "
                    ></use>
                  </svg>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="line2"></div>
          <div class="title">
            <span class="line"></span>
            <span>访问有效时长</span>
          </div>
          <div class="radio">
            <el-radio-group
              v-model="general.accessValidDays"
              @change="isChanged = true"
            >
              <el-radio :label="-1">永久有效</el-radio>
              <el-radio :label="30">30天</el-radio>
              <el-radio :label="7">7天</el-radio>
              <el-radio :label="1">1天</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!--模块数据权限-->
        <div
          class="formContainer3"
          v-show="tabsActive === 1"
        >
          <div class="left">
            <ul class="SettingDialog-checkbox-group">
              <li
                :class="checkboxActive === 1 ? 'active' : ''"
                @click="checkboxActive = 1"
              >
                <el-checkbox
                  v-model="modelData.layer"
                  @change="
                    modelData.layer = true
                    isChanged = true
                  "
                  disabled
                ></el-checkbox>
                <span style="color: rgb(204, 204, 204)">图层管理</span>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li
                :class="checkboxActive === 2 ? 'active' : ''"
                @click="checkboxActive = 2"
              >
                <el-checkbox
                  v-model="modelData.viewpoint"
                  @change="val=>{isChanged = true;checkedAllByPoint(val)}"
                ></el-checkbox>
                视点管理
                <i class="el-icon-arrow-right"></i>
              </li>
              <li
                :class="checkboxActive === 3 ? 'active' : ''"
                @click="checkboxActive = 3"
              >
                <el-checkbox
                  v-model="modelData.path"
                  @change="val=>{isChanged = true;checkedAllByPath(val)}"
                ></el-checkbox>
                路径规划
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>
          <!--图层管理-->
          <div
            class="right"
            v-show="checkboxActive === 1"
            style="overflow-x: hidden"
          >
            <div class="title">
              <span class="line"></span>
              <span>图层列表</span>
            </div>
            <div class="checkbox">
              <el-checkbox
                v-model="modelData.layerListShow"
                @change="isChanged = true"
                >显示</el-checkbox
              >
            </div>
            <div class="line2"></div>
            <div class="title">
              <span class="line"></span>
              <span>隐藏标注资源</span>
            </div>
            <div class="checkbox">
              <el-checkbox
                v-model="modelData.markSourceDataShow"
                @change="isChanged = true"
                >图片/视频
                <span style="color: #6f7172"></span></el-checkbox
              >
              <el-checkbox
                v-model="modelData.markSourceAttachmentShow"
                @change="isChanged = true"
                >文档
                <span style="color: #6f7172"
                  >（pdf）</span
                ></el-checkbox
              >
            </div>
            <div class="line2"></div>
            <div class="title">
              <span class="line"></span>
              <span>图层数据</span>
            </div>
            <el-tree
              :data="markerTreeData"
              ref="markerTree"
              :props="defaultProps"
              show-checkbox
              node-key="id"
              @check-change="isChanged = true"
              style="transform: translateX(5px)"
            >
              <span slot-scope="{ data }" class="custom-markerTree">
                <Icon
                  type="small"
                  name="icon-noodles-a"
                  v-if="data.name !== '全选' && data.type === 'PLANE'"
                ></Icon>
                <Icon
                  type="small"
                  name="icon-dian"
                  v-if="data.name !== '全选' && data.type === 'POINT'"
                ></Icon>
                <Icon
                  type="small"
                  name="icon-Line-a2"
                  v-if="data.name !== '全选' && data.type === 'LINE'"
                ></Icon>
                <Icon
                  type="small"
                  name="icon-folder-b"
                  v-if="data.name !== '全选' && !data.type"
                ></Icon>
                <span>{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
          <!--视点管理-->
          <div class="right" v-show="checkboxActive === 2">
            <el-tree
              @check-change="checkChange"
              :data="viewTreeData"
              ref="viewTreeData"
              :props="defaultProps"
              show-checkbox
              node-key="id"
            ></el-tree>
            <el-tree
              @check-change="checkChange"
              :data="viewTreeData2"
              ref="viewTreeData2"
              :props="defaultProps"
              show-checkbox
              node-key="id"
            ></el-tree>
          </div>
          <!--路径规划-->
          <div class="right" v-show="checkboxActive === 3">
            <el-tree
              @check-change="checkChange2"
              :data="planTreeData"
              ref="planTreeData"
              :props="defaultProps"
              show-checkbox
              node-key="id"
            ></el-tree>
          </div>
        </div>
      </div>
      <div
        class="codeBox"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        v-if="dialogType !== 0"
      >
        <el-form :model="general" ref="editForm" :rules="rules" class="share-info-form" hide-required-asterisk label-position="right" label-width="80px" label-suffix=":">
          <el-form-item label="分享名称" prop="name">
            <el-input v-model="general.name" placeholder="请输入20字以内" :maxlength="20" :disabled="dialogType===1 || dialogType===3" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="链接地址">
            <el-input :value="link" :readonly="true" disabled placeholder="未分享">
              <span slot="suffix" class="share-link disable" v-if="leaveTime<=0">链接已失效请重新分享</span>
              <span slot="suffix" class="share-link" v-else-if="leaveTime>30*24*60*60*1000">链接永久有效</span>
              <span slot="suffix" class="share-link" v-else>链接{{millsToTime(leaveTime)}}后失效</span>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col :span="14">
              <el-form-item label="分享密码">
                <el-input :value="general.accessPassword" :readonly="true" disabled placeholder="无密码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-button class="btn" type="primary" @click="copy">复制名称、链接及密码</el-button>
            </el-col>
          </el-row>
          <el-form-item label="二维码">
            <div class="tips">分享二维码，扫一扫查看项目</div>
          </el-form-item>
        </el-form>
        <div class="code-img">
          <img
            :src="
              baseurl +
              'platform/publics/create/qrCode?content=' +
              encodeLink +
              '&type=STREAM'
            "
            alt="img"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="dialogType === 0">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onCreate"  :loading="loading" :disabled="permissionLevel <= PermissionLevel.LOOKER">提交</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="dialogType === 1">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="dialogType = 2" :disabled="leaveTime<=0 || permissionLevel <= PermissionLevel.LOOKER">编辑</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="dialogType === 2">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onModify" :disabled="permissionLevel <= PermissionLevel.LOOKER">提交</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="dialogType === 3">
        <el-button @click="onCancel">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLayerTree,
  getViewPointList,
  getViewAnimationList,
  getRoutes,
  getShareMapSetting,
  createShare,
  updateShare
} from '@/api/mapManagement'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
import { millsToTime } from '@/utils/util'

export default {
  name: 'MapShareDialog',
  props: {},
  components: {},
  data () {
    return {
      // 分享id
      shareId: '',
      // 短码
      nonceStr: '',
      // 剩余到期时间
      leaveTime: 0,
      isShow: false,
      loading: false,
      // 窗口模式0创建，1查看，2编辑，3分享成功
      dialogType: 1,
      mapId: 0,
      baseurl: process.env.VUE_APP_API_BASE_URL,
      version: '',
      PermissionLevel,

      tabsActive: 0,
      checkboxActive: 1,
      checked: false,
      isShowPassword: false,
      rules: {
        accessPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 4,
            max: 12,
            message: '长度在 4 到 12 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          { required: true, message: '请输入分享名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ]
      },
      markerTreeData: [
        {
          id: -1,
          name: '全选',
          children: []
        }
      ], // 图层数数据
      viewTreeData: [
        {
          id: -1,
          name: '视点管理',
          children: []
        }
      ], // 视点管理树数据
      viewTreeData2: [
        {
          id: -1,
          name: '视点动画',
          children: []
        }
      ], // 视点动画树数据
      planTreeData: [
        {
          id: -1,
          name: '全选',
          children: []
        }
      ], // 路径树数据
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isCheckedAll: true, // 是否全选图层数据,
      general: {
        name: '',
        // 通用设置
        accessPasswordEnable: false,
        accessPassword: '',
        accessValidDays: -1,
        switchs: true
      },
      modelData: {
        // 模块设置
        layerListShow: true,
        markSourceAttachmentShow: true,
        markSourceDataShow: true,
        layer: true,
        viewpoint: true,
        path: true
      },
      isChanged: false,
      clickBtnCount: 0
    }
  },
  computed: {
    ...mapGetters(['permissionLevel']),
    link () {
      return this.composition(this.nonceStr)
    },
    encodeLink () {
      return window.encodeURIComponent(this.link)
    }
  },
  methods: {
    millsToTime,
    open ({ mapId, dialogType, shareId, name, nonceStr, switchs, accessPassword, createTime, accessExpiredTime }) {
      this.mapId = mapId
      this.shareId = shareId
      this.nonceStr = nonceStr ?? ''
      this.general.name = name
      this.general.switchs = switchs
      this.general.accessPassword = accessPassword
      this.dialogType = dialogType
      this.isShow = true

      if (this.dialogType === 0) {
        // 默认全选图层管理的图层数据
        this.$nextTick(async () => {
          await this.getLayerTree()
          await this.getViewPointList()
          await this.getViewAnimationList()
          await this.getRoutes()
          this.selectAllModel()
        // await this.getShareMapSetting()
        })
      } else {
        this.leaveTime = new Date(accessExpiredTime) - new Date(createTime)
      }
    },
    closeDialog () {
      this.$emit('refresh')
    },
    /**
     * 合成分享路径
     * @param {String} short 短链，必填项，baseurl目录
     */
    composition (short, baseurl = '/share') {
      return `${window.location.origin}${baseurl}/${short}`
    },
    copy () {
      let copyValue = `分享地图：${this.general.name}\r\n访问地址：${this.link}`
      if (this.general.accessPassword) {
        copyValue = copyValue + `\r\n访问密码：${this.general.accessPassword}`
      }
      const aux = document.createElement('textarea')
      // aux.setAttribute('value', copyValue)
      aux.textContent = copyValue
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$Message('success', '复制成功')
    },
    selectAllModel () {
      this.modelData = this.$options.data().modelData
      this.$refs.markerTree.setCheckedNodes(this.markerTreeData)
      this.$refs.viewTreeData.setCheckedNodes(this.viewTreeData)
      this.$refs.viewTreeData2.setCheckedNodes(this.viewTreeData2)
      this.$refs.planTreeData.setCheckedNodes(this.planTreeData)
    },
    // 获取分享配置
    async getShareMapSetting () {
      const res = await getShareMapSetting(this.nonceStr)
      if (res.code === 200) {
        Object.keys(this.general).forEach((k) => {
          this.general[k] = res.data.general[k]
        })
        Object.keys(this.modelData).forEach((k) => {
          this.modelData[k] = res.data.data[k]
        })
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedKeys(res.data.data.layerIds)
          this.$refs.viewTreeData.setCheckedKeys(res.data.data.viewpointIds)
          this.$refs.viewTreeData2.setCheckedKeys(
            res.data.data.viewpointAnimationIds
          )
          this.$refs.planTreeData.setCheckedKeys(res.data.data.pathIds)
        })
        setTimeout(() => {
          this.isChanged = false
        }, 500)
      }
    },
    // 开启密码设置
    changePsdCheck (v) {
      this.isChanged = true
      if (!v) {
        this.general.accessPassword = ''
      }
    },
    // 全选图层数据
    checkedAll () {
      if (this.isCheckedAll) {
        // 全选
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedNodes(this.markerTreeData)
        })
      } else {
        // 取消选中
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedKeys([])
        })
      }
    },
    // 全选视点数据
    checkedAllByPoint (checked) {
      this.isChanged = true
      if (checked) {
        // 全选
        this.$nextTick(() => {
          this.$refs.viewTreeData.setCheckedNodes(this.viewTreeData)
          this.$refs.viewTreeData2.setCheckedNodes(this.viewTreeData2)
        })
      } else {
        // 取消选中
        this.$nextTick(() => {
          this.$refs.viewTreeData.setCheckedKeys([])
          this.$refs.viewTreeData2.setCheckedKeys([])
        })
      }
    },
    // 全选路径规划数据
    checkedAllByPath (checked) {
      this.isChanged = true
      if (checked) {
        // 全选
        this.$nextTick(() => {
          this.$refs.planTreeData.setCheckedNodes(this.planTreeData)
        })
      } else {
        // 取消选中
        this.$nextTick(() => {
          this.$refs.planTreeData.setCheckedKeys([])
        })
      }
    },
    // 获取图层树数据
    async getLayerTree () {
      const res = await getLayerTree(
        {
          mapId: this.mapId
        },
        this.nonceStr
      )
      if (res.code === 200) {
        this.markerTreeData[0].children = res.data.children
      }
    },
    // 获取视点管理列表
    async getViewPointList () {
      const res = await getViewPointList(
        {
          mapId: this.mapId
        },
        this.nonceStr
      )
      if (res.code === 200) {
        this.viewTreeData[0].children = res.data
      }
    },
    // 获取视点动画列表
    async getViewAnimationList () {
      const res = await getViewAnimationList(
        {
          mapId: this.mapId
        },
        this.nonceStr
      )
      if (res.code === 200) {
        this.viewTreeData2[0].children = res.data
      }
    },
    // 获取路径规划列表
    async getRoutes () {
      const res = await getRoutes(this.mapId, this.nonceStr)
      if (res.code === 200) {
        this.planTreeData[0].children = res.data.records
      }
    },
    checkChange (v) {
      this.isChanged = true
      if (
        this.$refs.viewTreeData.getCheckedKeys().length > 0 ||
        this.$refs.viewTreeData2.getCheckedKeys().length > 0
      ) {
        this.modelData.viewpoint = true
      }
    },
    checkChange2 (v) {
      this.isChanged = true
      if (this.$refs.planTreeData.getCheckedKeys().length > 0) {
        this.modelData.path = true
      }
    },
    onCancel () {
      this.isShowPassword = false
      this.general = this.$options.data().general
      this.modelData = this.$options.data().modelData
      this.tabsActive = 0
      if (this.$refs.nameForm) {
        this.$refs.nameForm.clearValidate()
      }
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate()
      }
      this.isShow = false
    },
    // 创建分享
    async onCreate () {
      if (!this.general.name) {
        this.$message.warning('请输入分享名称')
        return
      }
      if (this.general.name.length > 20) {
        this.$message.warning('分享名称不能超过20字')
        return
      }
      if (this.general.accessPasswordEnable && !this.general.accessPassword) {
        this.$message.warning('请输入分享密码')
        return
      }
      if (this.general.accessPasswordEnable && (this.general.accessPassword.length < 4 || this.general.accessPassword.length > 12)) {
        this.$message.warning('分享密码长度不能小于4，大于12')
        return
      }
      await this.$refs.nameForm.validate()
      if (this.general.accessPasswordEnable) {
        await this.$refs.ruleForm.validate()
      }
      this.modelData.layerIds = this.$refs.markerTree.getCheckedKeys() // 图层节点
      this.modelData.halfFolderIds = this.$refs.markerTree.getHalfCheckedKeys() // 文件夹半节点
      this.modelData.viewpointIds = this.$refs.viewTreeData.getCheckedKeys()
      this.modelData.viewpointAnimationIds =
        this.$refs.viewTreeData2.getCheckedKeys()
      this.modelData.pathIds = this.$refs.planTreeData.getCheckedKeys()
      const params = {
        mapId: this.mapId,
        // version: this.version,
        data: this.modelData,
        general: this.general
      }
      this.loading = true
      try {
        const res = await createShare(params)
        if (res.code === 200) {
          // this.closeDialog()
          this.$emit('refresh')
          this.nonceStr = res.data.nonceStr ?? ''
          this.shareId = res.data.id
          this.general.name = res.data.name
          this.general.switchs = res.data.switchs
          this.general.accessPassword = res.data.accessPassword
          this.leaveTime = new Date(res.data.accessExpiredTime) - new Date(res.data.createTime)

          this.dialogType = 3
          this.$message.success()
          this.loading = false
        }
      } catch {
        this.loading = false
      }
    },
    // 编辑分享
    async onModify () {
      // if (!this.general.name) {
      //   this.$message.warning('请输入分享名称')
      //   return
      // }
      // if (this.general.name.length > 20) {
      //   this.$message.warning('分享名称不能超过20字')
      //   return
      // }
      await this.$refs.editForm.validate()
      const res = await updateShare({
        'id': this.shareId,
        'name': this.general.name,
        'switchs': this.general.switchs
      })
      if (res.code === 200) {
        // this.closeDialog()
        this.$emit('refresh')
        this.dialogType = 1
        this.$message.success()
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.MapShareDialog {
  .formTitle {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 20px 10px;
    box-sizing: border-box;
    margin-bottom: 10px;
    .text {
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      margin-left: 20px;
      > span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: #bbbbbb;
      }
      > span:first-child {
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 4px;
      }
    }
    .switch {
      position: relative;
      margin-left: 40px;
      .open {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
        left: 7px;
        top: 1px;
        z-index: 1000;
        position: absolute;
        pointer-events: none;
      }
      .close {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
        right: 7px;
        top: 1px;
        position: absolute;
      }
    }
  }
  .line3{
    display: inline-block;
    width: 100%;
    height: 1px;
    background-color: white;
    opacity: 0.1;
    margin-bottom: 12px;
  }
  .formContainer {
    .tabs {
      width: 240px;
      height: 32px;
      background: #3d3e40;
      border: 1px solid #00a4f0;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      margin-bottom: 16px;
      > span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: #ffffff;
        display: inline-block;
        width: 50%;
        height: 100%;
        line-height: 30px;
        cursor: pointer;
        transition: all 0.3s;
        &.active {
          background: #00a4f0;
        }
      }
    }
  }
  .formContainer2 {
    width: 560px;
    height: 335px;
    background: #303133;
    border-radius: 6px;
    padding: 16px 20px;
    box-sizing: border-box;
    text-align: left;
    .title {
      margin-bottom: 12px;
      > span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #ffffff;
        display: inline-block;
      }
      .line {
        width: 3px;
        height: 10px;
        background: #ffffff;
        border-radius: 2px;
        margin-right: 8px;
      }
    }
    .checkbox {
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 11px;
      > span {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: rgba(242, 171, 63, 0.8);
      }
    }
    .input {
      padding: 0 10px;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
    .radio {
      padding: 0 10px;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
    .line2 {
      width: 520px;
      height: 1px;
      background-color: white;
      opacity: 0.1;
      margin-bottom: 12px;
      margin-top: 10px;
    }
    .show-password {
      transform: translate(-6px, 1.5px);
    }
  }
  .formContainer3 {
    width: 560px;
    height: 335px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      width: 140px;
      height: 335px;
      background: #303133;
      border-radius: 6px;
      padding: 16px 8px;
      box-sizing: border-box;
      .SettingDialog-checkbox-group {
        list-style: none;
        margin: 0;
        padding: 0;
        > li {
          width: 124px;
          height: 32px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          cursor: pointer;
          color: white;
          font-size: 14px;
          padding-left: 13px;
          box-sizing: border-box;
          transition: all 0.3s;
          &:hover {
            background: #334966;
          }
          &.active {
            background: #334966;
          }
          .el-checkbox {
            width: 14px;
            height: 14px;
            line-height: 0;
            margin-right: 8px;
            transform: translateY(-2px);
          }
          > i {
            display: inline-block;
            transform: translateX(15px);
            color: rgba(232, 232, 232, 0.8);
            font-size: 12px;
          }
        }
      }
    }
    .right {
      width: 408px;
      height: 335px;
      background: #303133;
      border-radius: 6px;
      padding: 20px;
      box-sizing: border-box;
      text-align: left;
      overflow-y: auto;
      .title {
        margin-bottom: 12px;
        > span {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          display: inline-block;
        }
        .line {
          width: 3px;
          height: 10px;
          background: #ffffff;
          border-radius: 2px;
          margin-right: 8px;
        }
      }
      .checkbox {
        padding-left: 10px;
        box-sizing: border-box;
        margin-bottom: 20px;
      }
      .line2 {
        width: 368px;
        height: 1px;
        background-color: white;
        opacity: 0.1;
        margin-bottom: 16px;
      }
    }
  }
  .codeBox {
    width: 560px;
    height: 374px;
    background: #303133;
    border-radius: 6px;
    padding: 20px;
    box-sizing: border-box;
    padding-right: 20px;
    position: relative;
    .code-img {
      width: 110px;
      height: 110px;
      border-radius: 10px;
      position: absolute;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 68px;
      > img {
        width: 95px;
        height: 95px;
      }
    }
    .share-link{
      font-size: 12px;
      color: #F2AB3F;
      &.disable{
        color: #F54949;
      }
    }
    .short{
      width: 220px;
    }
    .text {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: #999999;
      position: absolute;
      top: 50px;
      left: 160px;
    }
    .btn {
      // width: 150px;
      // height: 32px;
      // border: 1px solid #00a4f0;
      // border-radius: 6px;
      // font-size: 12px;
      // font-family: Source Han Sans SC;
      // font-weight: 400;
      // color: #00a4f0;
      // line-height: 30px;
      margin: 4px 46px;
      // cursor: pointer;
    }
    .tips{
      text-align: left;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFEFE;
    }
  }
}
</style>
<style lang="scss">
.MapShareDialog {
  .customDialog {
    .el-dialog {
      width: 600px;
      .el-switch__core {
        border-color: rgba(255, 255, 255, 0) !important;
      }
    }
    .formContainer3 {
      .el-tree {
        background-color: rgba(255, 255, 255, 0) !important;
        .el-tree-node {
          background-color: rgba(255, 255, 255, 0) !important;
        }
        .el-tree-node:focus > .el-tree-node__content {
          background-color: rgba(255, 255, 255, 0) !important;
        }
        .el-tree-node__content {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .custom-markerTree {
            display: flex;
            align-items: center;
            .custom-icon {
              margin-right: 6px;
              margin-left: -6px;
              > svg {
                color: rgba(255, 255, 255, 0.3);
              }
            }
          }
        }
      }
    }
    .el-tree .el-tree-node.is-current > .el-tree-node__content:first-child {
      color: unset !important;
    }
    .el-checkbox .el-checkbox__input .el-checkbox__inner {
      border: 1px solid rgba(55, 56, 57, 0);
    }
    .share-info-form{
      .el-form-item{
        margin-bottom: 18px;
      }
    }
  }
}
</style>
